(() => {
  if (window.mmaAuthorDisclosureReady) return;
  window.mmaAuthorDisclosureReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-author-disclosure-toggle]');
    if (!button) return;

    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    const willExpand = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(willExpand));
    panel.hidden = !willExpand;
  });
})();
